/* eslint-disable */
import { Flex, Text, Button, Box, Heading, Icon } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FaHeart, FaStar, FaMagic } from "react-icons/fa";

const Section1 = () => {
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      w="full"
      bg="white"
      h="100dvh"
      maxH="100dvh"
      overflow="hidden"
      display="flex"
      alignItems="center"
      pt="72px"
    >
      <Flex
        direction={{ base: "column", lg: "row" }}
        align="center"
        justify="space-between"
        maxW="1400px"
        mx="auto"
        px={{ base: 6, md: 12 }}
        gap={{ base: 8, lg: 12 }}
        w="full"
        h="full"
        maxH="calc(100dvh - 72px)"
      >
        {/* LEFT COLUMN: Text Content */}
        <Box flex={1} maxW="560px" py={4}>


          {/* Main Heading — scaled down to fit in viewport */}
          <Heading
            fontSize={{ base: "3xl", md: "5xl", lg: "5xl" }}
            fontWeight="700"
            lineHeight="1.05"
            letterSpacing="-2px"
            color="black"
            mb={5}
          >
            Empowering Talent with AI-Powered Corporate Training
          </Heading>

          {/* Subtext */}
          <Text
            fontSize={{ base: "sm", md: "md" }}
            color="gray.600"
            mb={8}
            lineHeight="1.6"
            fontWeight="500"
            maxW="420px"
          >
            Unlock Your Team’s Full Potential. SkillUp delivers AI-powered learning, real-time analytics, and seamless skill-building designed to elevate performance and drive measurable results.
          </Text>

          {/* CTA */}
          <Button
            size="lg"
            h="52px"
            px={8}
            borderRadius="full"
            fontSize="md"
            fontWeight="600"
            bg="black"
            color="white"
            _hover={{ bg: "gray.800", transform: "translateY(-2px)" }}
            transition="all 0.3s"
            onClick={() => process.env.REACT_APP_DEV_ALLOW_PASSWORD_LOGIN === 'true' ? navigate('/login') : window.alert("Please access the LMS directly from your HCM Dashboard.")}
          >
            Get Started
          </Button>
        </Box>

        {/* RIGHT COLUMN: Image & Widgets */}
        <Box
          flex={1}
          position="relative"
          w="full"
          h="100%"
          maxH="calc(100dvh - 120px)"
          borderRadius="3xl"
          overflow="hidden"
          boxShadow="xl"
          display={{ base: "none", lg: "block" }}
        >
          {/* Background Image */}
          <Box
            position="absolute"
            top={0} left={0} w="full" h="full"
            bgImage="url('https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1000&q=80')"
            bgSize="cover"
            bgPosition="center"
          />

          {/* Top-right widget: Course Progress */}
          <Box
            position="absolute" top="8%" right="8%"
            bg="white" borderRadius="2xl" p={4} w="220px" boxShadow="lg"
          >
            <Flex justify="space-between" align="center" mb={3}>
              <Text fontSize="10px" fontWeight="700" color="gray.500">Course Completion</Text>
              <Text fontSize="10px" fontWeight="700" color="gray.400">⏱ 12m 30s</Text>
            </Flex>
            <Flex gap={2}>
              <Box flex={1} bg="#FF71E8" borderRadius="md" p={2} h="70px" display="flex" flexDir="column" justify="space-between">
                <Text fontSize="10px" fontWeight="700" color="white">Completed</Text>
                <Text fontSize="sm" fontWeight="800" color="white">82.45%</Text>
              </Box>
              <Flex flex={1} direction="column" gap={2}>
                <Box bg="#D6F5E1" borderRadius="md" p={2} flex={1}>
                  <Text fontSize="10px" fontWeight="700" color="gray.600">Pending</Text>
                  <Text fontSize="sm" fontWeight="800" color="gray.800">23.4%</Text>
                </Box>
                <Box bg="#54E8B0" borderRadius="md" p={2} flex={1}>
                  <Text fontSize="10px" fontWeight="700" color="white">Active</Text>
                  <Text fontSize="sm" fontWeight="800" color="white">76.6%</Text>
                </Box>
              </Flex>
            </Flex>
          </Box>

          {/* Bottom-left widget: Chat bubble */}
          <Flex
            position="absolute" bottom="15%" left="8%"
            bg="white" borderRadius="full" py={3} px={5}
            align="center" gap={3} boxShadow="lg"
          >
            <Box bg="#4285F4" p={2} borderRadius="full" color="white">
              <FaHeart size="12" />
            </Box>
            <Text fontSize="sm" fontWeight="600" color="gray.800" lineHeight="1.2">
              Love it! Going to<br />start my next module
            </Text>
          </Flex>


        </Box>
      </Flex>
    </Box>
  );
};

export default Section1;
